import React from "react"

const Facebook = props => (
  <svg viewBox="0 0 38 38" {...props}>
    <path d="M18.648 0C8.392 0 0 8.392 0 18.648s8.392 18.648 18.648 18.648 18.648-8.392 18.648-18.648S28.904 0 18.648 0zm5.594 17.871H20.98v10.878h-4.662V17.871H13.21v-3.108h3.108v-1.865c0-1.71.622-4.351 4.04-4.351h3.73v3.574h-2.176c-.31 0-.932.156-.932.933v1.554h3.574l-.31 3.263z" />
  </svg>
)

export default Facebook
